export const Marquee = ({ text }) => {
  const items = Array(6).fill(text);
  return (
    <div className="pointer-events-none overflow-hidden py-6" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-16">
        {[...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-heading text-6xl font-extrabold uppercase tracking-tight text-outline md:text-8xl"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};
